import { render, staticRenderFns } from "./GroupLevelAttributeBooleanField.vue?vue&type=template&id=70c4d029&"
import script from "./GroupLevelAttributeBooleanField.vue?vue&type=script&lang=ts&"
export * from "./GroupLevelAttributeBooleanField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports